import { render, staticRenderFns } from "./find-answer.vue?vue&type=template&id=e962264a&"
import script from "./find-answer.vue?vue&type=script&lang=js&"
export * from "./find-answer.vue?vue&type=script&lang=js&"
import style0 from "./find-answer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports